/* reducer is used in client area */
import { FETCH_FOCUS_AREAS, USER_LOGOUT, UPDATE_FOCUS_AREA, ADD_FOCUS_AREA,DELETE_FOCUS_AREA }  from"actions/actionTypes";

var _ = require('lodash');

const initialState = {data: [] };
export default function (state = initialState, action) {
    switch (action.type) {
        case FETCH_FOCUS_AREAS:
            console.log(FETCH_FOCUS_AREAS, action.payload);
            return {
                data: action.payload.data,
            }
        case UPDATE_FOCUS_AREA:
            console.log(`UPDATE_FOCUS_AREA${action.payload}`);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload._id});
            return {
                data: [...state.data.slice(0, itemIndex),
                    action.payload,
                    ...state.data.slice(itemIndex + 1)]
            }
        case ADD_FOCUS_AREA:
            console.log("ADD_FOCUS_AREA", action);
            return {
                data: _.concat(state.data, [action.payload]),
            }
        case DELETE_FOCUS_AREA:
            console.log(`DELETE_FOCUS_AREA${action.payload}`);
            var itemIndex = _.findIndex(state.data, {'_id': action.payload.FocusAreaID});
            return {
                data: [...state.data.slice(0, itemIndex),
                    ...state.data.slice(itemIndex + 1)],
            }
        case USER_LOGOUT:
            return initialState;
        default:
            return state;
    }
}
